import { AxiosInstance } from 'axios';
import * as NationalityForecastReportService from './services';

export type NationalityForecastReportServiceType = ReturnType<
  typeof NationalityForecastReportService.exportPDF
>;

export const initNationalityForecastReportService = (
  axios: AxiosInstance
): NationalityForecastReportServiceType => NationalityForecastReportService.exportPDF(axios);
